module.exports = __webpack_public_path__ + "img/sky.2a7cbfca.jpg";